export * from "./breadcrumb.component";


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/breadcrumb/index.ts